<template>
  <div class="customer-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t("accounts.title") }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="dashboard">
            {{ $t("general.home") }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="/super-admin/accounts">
            {{ $tc("accounts.account", 2) }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">
            {{ $t("general.connect_to_auditor") }}
          </router-link>
        </li>
      </ol>
    </div>
    <SingleAccountRow :fetchData="fetchFunderData" :tableDivId="tableDivId" />
    <div
      v-cloak
      v-show="showEmptyScreen"
      class="col-xs-1 no-data-info"
      align="center"
    >
      <astronaut-icon class="mt-5 mb-4" />
      <div class="row" align="center">
        <label class="col title">{{ $t("accounts.no_accounts") }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{
          $t("accounts.list_of_accounts")
        }}</label>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">
          {{ $t("general.showing") }}: <b>{{ totalAuditAccounts }}</b>
        </p>

        <transition name="fade" v-if="connectAuditDisable == false">
          <v-dropdown v-if="selectedAuditAccount > 0" :show-arrow="false">
            <span
              slot="activator"
              href="#"
              class="table-actions-button dropdown-toggle"
            >
              {{ $t("general.actions") }}
            </span>
            <v-dropdown-item>
              <div class="dropdown-item" @click="connectFundertoAudit">
                <font-awesome-icon
                  icon="paper-plane"
                  class="dropdown-item-icon"
                />
                {{ $t("general.connect_to_auditor") }}
              </div>
            </v-dropdown-item>
          </v-dropdown>
        </transition>
      </div>

      <div class="custom-control"></div>

      <table-component
        ref="table"
        :show-filter="false"
        :data="fetchData"
        table-class="table"
      >
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-radio">
              <input
                :disabled="connectAuditDisable"
                :id="row.id"
                v-model="selectAuditAccountField"
                :value="row.id"
                type="radio"
                class="custom-control-input"
              />
              <label :for="row.id" class="custom-control-label" />
            </div>
          </template>
        </table-column>

        <table-column
          :label="$t('accounts.company_name')"
          show="company_name"
        />
        <table-column :label="$t('accounts.phone')" show="phone" />

        <table-column
          :label="$t('accounts.added_on')"
          sort-as="created_at"
          show="formattedCreatedAt"
        />

        <table-column
          :label="$t('accounts.status')"
          sort-as="status"
          show="UpperCaseStatus"
        />
      </table-component>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DotIcon from "../../../components/icon/DotIcon";
import AstronautIcon from "../../../components/icon/AstronautIcon.vue";
import SingleAccountRow from "./SingleAccountRow.vue";
export default {
  components: {
    DotIcon,
    AstronautIcon,
    SingleAccountRow
  },
  data() {
    return {
      fetchFunderData: [],
      tableDivId: "tableDivId",
      isRequestOngoing: true,
      connectAuditDisable: false,
      totalAuditAccounts: 0
    };
  },
  created() {
    this.loadAccount();
  },
  computed: {
    ...mapGetters("account", [
      "accounts",
      "selectedAccounts",
      "selectedAuditAccount",
      "totalAccounts",
      "selectAllField",
      "funderAccounts",
      "totalFunderAccounts",
      "selectAllFunderField"
    ]),
    showEmptyScreen() {
      return !this.totalAuditAccounts && !this.isRequestOngoing;
    },
    filterIcon() {
      return this.showFilters ? "times" : "filter";
    },
    selectAuditAccountField: {
      get: function() {
        return this.selectedAuditAccount;
      },
      set: function(val) {
        this.selectAuditAccount(val);
      }
    }
  },
  methods: {
    ...mapActions("account", [
      "fetchViewAccount",
      "fetchFunderFreeAudit",
      "selectAuditAccount",
      "connectFunderAuditAccount"
    ]),

    async loadAccount() {
      this.isRequestOngoing = true;
      let response = await this.fetchViewAccount(this.$route.params.id);
      if (response.data) {
        this.fetchFunderData.push(response.data.account);
      }
      this.isRequestOngoing = false;
    },
    async fetchData({ page, per_page, filter, sort }) {
      let data = {
        orderByField: sort.fieldName || "users.created_at",
        orderBy: sort.order || "desc",
        status: "active",
        per_page, // Add rowsPerPage in the API request
        page
      };
      this.isRequestOngoing = true;
      let response = await this.fetchFunderFreeAudit(data);
      this.isRequestOngoing = false;
      this.userAccounts = response.data.accounts.data;
      this.totalAuditAccounts = response.data.accounts.total;
      return {
        data: this.userAccounts,
        pagination: {
          totalPages: response.data.accounts.last_page,
          currentPage: page,
          rowsPerPage: response.data.accounts.per_page // Add rowsPerPage in the API request
        }
      };
    },
    async connectFundertoAudit() {
      let data = {
        funderId: this.$route.params.id,
        auditId: this.selectedAuditAccount
      };
      this.isRequestOngoing = true;
      this.connectAuditDisable = true;
      this.isLoading = true;
      let response = await this.connectFunderAuditAccount(data);

      if (response.data.success) {
        this.$router.push("/super-admin/accounts");
        window.toastr["success"](
          this.$tc("accounts.funder_audit_link_successful")
        );
      }
    }
  }
};
</script>
<style scoped>
#tableDivId {
  min-height: 0px;
}
</style>
